import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-eac41a52")
const _hoisted_1 = { class: "web-iframe" }
const _hoisted_2 = ["src", "width", "height"]
const _hoisted_3 = {
  key: 0,
  class: "web-iframe-back"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "back-btn-text" }, "返回", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      src: _ctx.webUrl,
      width: _ctx.webWidth,
      height: _ctx.webHeight,
      frameborder: 0,
      scrolling: 'auto'
    }, "\n    ", 8, _hoisted_2),
    (_ctx.backBtnVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "back-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleGoBackToLogin && _ctx.handleGoBackToLogin(...args)))
          }, [
            _createVNode(_component_el_icon, { class: "left-right-icon" }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowLeft)
              ]),
              _: 1
            }),
            _hoisted_4
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}